import React, { createContext, useState, useContext, useEffect } from 'react'
import {
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
    onAuthStateChanged
} from 'firebase/auth'
import { auth } from '../firebase'

const AuthContext = createContext()

// List of authorized admin emails
const AUTHORIZED_EMAILS = [
    // Add your authorized email addresses here
    'ahmedxarfraz@gmail.com',
    'hassan.edu.pk@gmail.com',
    'jsmoskowitz@gmail.com',
    'waqararifmangat@gmail.com'
]

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user && AUTHORIZED_EMAILS.includes(user.email)) {
                setUser(user)
            } else {
                setUser(null)
                if (user) {
                    // If user is logged in but not authorized, sign them out
                    await signOut(auth)
                }
            }
            setLoading(false)
        })

        return unsubscribe
    }, [])

    const signInWithGoogle = async () => {
        const provider = new GoogleAuthProvider()
        try {
            const result = await signInWithPopup(auth, provider)
            if (!AUTHORIZED_EMAILS.includes(result.user.email)) {
                await signOut(auth)
                throw new Error('Unauthorized email address')
            }
            return result
        } catch (error) {
            throw error
        }
    }

    const logout = async () => {
        try {
            await signOut(auth)
            setUser(null)
        } catch (error) {
            console.error('Error signing out:', error)
        }
    }

    const value = {
        user,
        signInWithGoogle,
        logout,
        isAdmin: user && AUTHORIZED_EMAILS.includes(user.email)
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    return useContext(AuthContext)
} 